import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CompleteOnboardingMutation,
  CompleteOnboardingMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const completeOnboardingDocument = graphql(`
  mutation completeOnboarding {
    completeOnboarding {
      success
    }
  }
`);

export function useCompleteOnboarding(
  options?: UseMutationOptions<
    CompleteOnboardingMutation,
    unknown,
    CompleteOnboardingMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(completeOnboardingDocument, options);
}
